import { CONTACT_FORM_URL } from "../constant/form";

export const submit = (data, cb) => {
    const params = {
      "entry.1490931066": data.name,
      "entry.1479677607": data.phone,
      "entry.2112242647": data.email,
      "entry.845071460": data.course,
      "entry.508718640": data.message,
      "submit": "Submit"
    }
    const finalUrl = CONTACT_FORM_URL + "?" + new URLSearchParams(params).toString();
    fetch(finalUrl).then(async (response) => {
        cb(response);
    }
    ).catch((error) => {
        cb(error);
    });
}